import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getCompPopup: ({ searchParams, currentPage, pageUnit }) => {
		let queryStr = '';

		let cpnyScn = searchParams.cpnyScn;

		if (searchParams.cpnyScn !== undefined) {
			queryStr = objectToQuerystring({
				cpnyScn: searchParams.cpnyScn,
				cpnyCd: searchParams.cpnyCd,
				currentPage,
				pageUnit
			});
		}

		return client
			.get(`${BASE_URL}/comm/commpopup/compPopup/v1/comps/cpnyScn/${cpnyScn}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
